import { appConfig } from '../../../../../../../config/customization';
import { defaultPaddingLeft } from '../../../../../../../constants/sizes';

export default {
  container: {
    display: 'flex',
    flex: 1,
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    padding: `0px 100px 0px ${defaultPaddingLeft}px`,
    backgroundColor: appConfig.colors.activeRowColor,
    width: '100%',
    overflow: 'visible',
    boxShadow: 'inset -2px -73px 46px -87px rgba(0,0,0,1)'
  },
  fieldContainer: {
    flexDirection: 'column',
    margin: '25px 0',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center'
  }
};
